const TEAL = "#1B6B6B";
const TEAL_PALE = "#E0F4F4";
const GOLD = "#E8C87A";
const GOLD_LIGHT = "#FDF6E3";
const WHITE = "#FFFFFF";
const DARK = "#0D2B2B";
const MID = "#2A4A4A";

function Logo({ size = 28 }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <svg width={size} height={size} viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="20" fill={TEAL} />
        <path d="M12 26 L20 14 L28 26" stroke={WHITE} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <circle cx="20" cy="14" r="3" fill={GOLD}/>
        <path d="M14 22 L26 22" stroke={WHITE} strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
      </svg>
      <span style={{ fontFamily: "'Georgia', serif", fontSize: size * 0.85, fontWeight: 700, color: TEAL, letterSpacing: "-0.5px" }}>
        match<span style={{ color: GOLD }}>kid</span>
      </span>
    </div>
  );
}

export default function CGVPage({ onBack }) {
  return (
    <div style={{ fontFamily: "system-ui", background: WHITE, minHeight: "100vh" }}>
      {/* NAV */}
      <nav style={{ borderBottom: "1px solid #E8F4F4", padding: "16px 5%", display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0, background: WHITE, zIndex: 100 }}>
        <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer" }}>
          <Logo size={24} />
        </button>
        <button onClick={onBack} style={{ fontFamily: "system-ui", fontSize: 14, color: TEAL, background: "none", border: "none", cursor: "pointer", fontWeight: 600 }}>
          ← Retour à l'accueil
        </button>
      </nav>

      {/* HEADER */}
      <div style={{ background: `linear-gradient(135deg, ${DARK}, ${TEAL})`, padding: "64px 5% 48px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <div style={{ fontFamily: "system-ui", fontSize: 12, fontWeight: 700, letterSpacing: 2, color: GOLD, textTransform: "uppercase", marginBottom: 16 }}>Matchkid</div>
          <h1 style={{ fontFamily: "'Georgia', serif", fontSize: "clamp(28px, 4vw, 44px)", fontWeight: 700, color: WHITE, margin: "0 0 16px" }}>
            Conditions Générales de Vente
          </h1>
          <p style={{ fontSize: 15, color: "rgba(255,255,255,0.6)", margin: 0 }}>Version 1.0 — Applicable à compter du 1er juin 2026</p>
        </div>
      </div>

      {/* CONTENU */}
      <div style={{ maxWidth: 800, margin: "0 auto", padding: "64px 5%" }}>

        {/* Infos légales */}
        <div style={{ background: TEAL_PALE, borderRadius: 16, padding: "24px 28px", marginBottom: 48 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEAL, marginBottom: 16 }}>Informations légales</div>
          {[
            ["Éditeur", "Matchkid — exploité par la SAS HUMAN SOLUTIONS"],
            ["Capital", "20 000 €"],
            ["SIRET", "500 801 469 00015"],
            ["Siège social", "16, rue Larrey – 75005 Paris"],
            ["Email", "contact@matchkid.fr"],
            ["Site web", "matchkid.fr"],
          ].map(([k, v], i) => (
            <div key={i} style={{ display: "flex", gap: 16, marginBottom: 8, fontSize: 14 }}>
              <span style={{ fontWeight: 700, color: DARK, minWidth: 120 }}>{k} :</span>
              <span style={{ color: MID }}>{v}</span>
            </div>
          ))}
        </div>

        {[
          {
            titre: "Article 1 — Objet et champ d'application",
            contenu: [
              "Les présentes Conditions Générales de Vente (ci-après « CGV ») régissent les relations contractuelles entre Matchkid (ci-après « le Prestataire ») et tout utilisateur (ci-après « le Client ») souhaitant acquérir l'accès au service de diagnostic de profil et de recommandation d'activités sportives et artistiques pour enfants et adolescents, disponible sur le site matchkid.fr.",
              "Toute commande passée sur le site matchkid.fr implique l'acceptation sans réserve des présentes CGV. Le Client déclare avoir pris connaissance des CGV et les accepter avant de procéder à toute commande.",
            ]
          },
          {
            titre: "Article 2 — Description du service",
            contenu: [
              "Matchkid est un outil de diagnostic en ligne qui :",
              ["Propose un questionnaire adapté à la tranche d'âge de l'enfant (5-7 ans, 8-11 ans, 12-14 ans ou 15-17 ans)", "Croise les réponses de l'enfant et des parents (selon la tranche d'âge) pour établir un profil", "Génère automatiquement un rapport PDF personnalisé contenant le profil de l'enfant, ses forces naturelles, les activités recommandées, les activités à éviter, et des conseils aux parents"],
              "Le rapport PDF est généré directement dans le navigateur du Client et peut être téléchargé immédiatement. Ce rapport constitue le livrable final du service.",
              { note: "Note importante : Matchkid est un outil d'aide à la décision, pas un outil de diagnostic psychologique certifié. Les recommandations sont fondées sur des cadres théoriques reconnus (intelligences multiples, modèle RIASEC, théorie de l'autodétermination) mais ne se substituent pas à l'avis d'un professionnel de l'enfance." }
            ]
          },
          {
            titre: "Article 3 — Tarifs et modalités de paiement",
            contenu: [
              "3.1 Tarif en vigueur",
              "Le prix du service Matchkid est fixé à 11,90 € TTC (toutes taxes comprises) par diagnostic, quelle que soit la tranche d'âge choisie.",
              "Ce prix comprend :",
              ["L'accès au questionnaire complet adapté à l'âge de l'enfant", "La génération du rapport PDF personnalisé", "Le téléchargement immédiat du rapport"],
              { note: "Le tarif peut être modifié à tout moment pour les nouvelles commandes. Le prix applicable est celui affiché sur le site au moment de la commande." },
              "3.2 Modalités de paiement",
              "Le paiement s'effectue en ligne, de manière sécurisée, via la plateforme Stripe. Les moyens de paiement acceptés sont :",
              ["Carte bancaire (Visa, Mastercard, American Express)", "Apple Pay et Google Pay"],
              "Le paiement est exigible immédiatement lors de la commande. L'accès au questionnaire n'est accordé qu'après confirmation du paiement.",
            ]
          },
          {
            titre: "Article 4 — Accès au service et livraison",
            contenu: [
              "Après confirmation du paiement, le Client reçoit immédiatement un accès au questionnaire Matchkid correspondant à la tranche d'âge sélectionnée.",
              "Une fois le questionnaire complété, le rapport PDF est généré instantanément et mis à disposition du Client pour téléchargement direct. Aucun délai de livraison n'est applicable, le service étant entièrement dématérialisé et automatisé.",
              "En cas de difficulté technique lors de la génération du rapport, le Client peut contacter le support à l'adresse contact@matchkid.fr dans un délai de 7 jours suivant la commande.",
            ]
          },
          {
            titre: "Article 5 — Droit de rétractation",
            contenu: [
              "Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux contenus numériques dont l'exécution a commencé avec l'accord préalable du consommateur avant l'expiration du délai de rétractation.",
              "En accédant au questionnaire après paiement, le Client reconnaît expressément renoncer à son droit de rétractation de 14 jours, conformément à la réglementation en vigueur.",
              { note: "Cependant, si le rapport PDF ne peut pas être généré en raison d'un dysfonctionnement technique imputable à Matchkid, le Client sera remboursé intégralement dans un délai de 7 jours ouvrés." }
            ]
          },
          {
            titre: "Article 6 — Protection des données personnelles et RGPD",
            contenu: [
              "6.1 Données collectées",
              "Matchkid a été conçu dans le respect de la vie privée des enfants et des familles. Le service ne collecte et ne stocke aucune donnée personnelle relative à l'enfant diagnostiqué.",
              "Plus précisément :",
              ["Le prénom de l'enfant, son âge et son sexe sont saisis par le Client mais ne sont jamais transmis ni stockés sur les serveurs de Matchkid", "Les réponses au questionnaire ne sont pas conservées après la génération du rapport", "Le rapport PDF est généré directement dans le navigateur du Client (traitement local) — Matchkid n'a accès à aucune copie du rapport", "Aucune adresse postale n'est collectée"],
              { gold: "Avantage RGPD majeur : Le service Matchkid ne constitue pas un traitement de données à caractère personnel au sens du RGPD pour ce qui concerne les données des enfants, dans la mesure où ces données ne sont jamais transmises, conservées ou traitées par Matchkid. Le rapport est entièrement généré côté client (navigateur), sans aucun stockage serveur des données individuelles." },
              "6.2 Données de transaction",
              "Les seules données collectées et traitées par Matchkid sont celles nécessaires à la transaction commerciale :",
              ["Adresse email (pour la confirmation de commande)", "Données de paiement (traitées exclusivement par Stripe — Matchkid ne stocke jamais les données bancaires)"],
              "Ces données sont conservées pour une durée de 5 ans conformément aux obligations comptables légales.",
              "6.3 Droits des utilisateurs",
              "Conformément au RGPD et à la loi Informatique et Libertés, le Client dispose d'un droit d'accès, de rectification, d'effacement et de portabilité de ses données personnelles de transaction. Ces droits peuvent être exercés en contactant contact@matchkid.fr.",
            ]
          },
          {
            titre: "Article 7 — Responsabilité",
            contenu: [
              "7.1 Portée des recommandations",
              "Les recommandations d'activités fournies par Matchkid sont établies sur la base des réponses au questionnaire et constituent une aide à la décision parentale. Matchkid ne peut garantir que les activités recommandées correspondront nécessairement aux attentes ou aux aptitudes effectives de l'enfant.",
              "Les parents demeurent les seuls décisionnaires quant au choix des activités pour leur enfant. Matchkid décline toute responsabilité quant aux décisions d'inscription ou aux conséquences de ces décisions.",
              "7.2 Limitation de responsabilité",
              "La responsabilité de Matchkid est limitée au montant de la commande passée par le Client. Matchkid ne saurait être tenu responsable de dommages indirects, immatériels ou consécutifs résultant de l'utilisation du service.",
            ]
          },
          {
            titre: "Article 8 — Propriété intellectuelle",
            contenu: [
              "L'ensemble des éléments constitutifs du service Matchkid — questionnaires, matrices de scoring, algorithmes de recommandation, textes, rapport PDF, interface — sont la propriété exclusive de Matchkid et sont protégés par le droit d'auteur.",
              "Toute reproduction, représentation, modification, publication ou transmission de ces éléments, par quelque moyen que ce soit, est interdite sans autorisation préalable écrite de Matchkid.",
              "Le rapport PDF généré pour le Client peut être utilisé à titre personnel. Il ne peut pas être reproduit, diffusé ou vendu à des fins commerciales.",
            ]
          },
          {
            titre: "Article 9 — Loi applicable et juridiction compétente",
            contenu: [
              "Les présentes CGV sont soumises au droit français.",
              "En cas de litige relatif à la formation, l'interprétation ou l'exécution des présentes CGV, le Client s'adressera en priorité à Matchkid pour tenter de résoudre le litige à l'amiable.",
              "En l'absence de résolution amiable, tout litige sera soumis aux tribunaux compétents du ressort du siège social de Matchkid.",
              "Conformément à l'ordonnance n°2015-1033 du 20 août 2015, tout litige de consommation peut faire l'objet d'une médiation. Le Client peut recourir gratuitement au service de médiation dont relève Matchkid.",
            ]
          },
          {
            titre: "Article 10 — Contact",
            contenu: [
              "Pour toute question relative aux présentes CGV ou au service Matchkid :",
            ]
          },
        ].map((article, i) => (
          <div key={i} style={{ marginBottom: 48 }}>
            <h2 style={{ fontFamily: "'Georgia', serif", fontSize: 20, fontWeight: 700, color: DARK, marginBottom: 20, paddingBottom: 12, borderBottom: `2px solid ${TEAL_PALE}` }}>
              {article.titre}
            </h2>
            {article.contenu.map((item, j) => {
              if (Array.isArray(item)) {
                return (
                  <ul key={j} style={{ margin: "12px 0", paddingLeft: 24 }}>
                    {item.map((li, k) => (
                      <li key={k} style={{ fontSize: 15, color: MID, lineHeight: 1.7, marginBottom: 8 }}>{li}</li>
                    ))}
                  </ul>
                );
              }
              if (typeof item === "object" && item.note) {
                return (
                  <div key={j} style={{ background: TEAL_PALE, borderLeft: `4px solid ${TEAL}`, padding: "14px 18px", borderRadius: "0 10px 10px 0", margin: "16px 0", fontSize: 14, color: MID, lineHeight: 1.7, fontStyle: "italic" }}>
                    {item.note}
                  </div>
                );
              }
              if (typeof item === "object" && item.gold) {
                return (
                  <div key={j} style={{ background: GOLD_LIGHT, borderLeft: `4px solid ${GOLD}`, padding: "14px 18px", borderRadius: "0 10px 10px 0", margin: "16px 0", fontSize: 14, color: "#6B5000", lineHeight: 1.7 }}>
                    {item.gold}
                  </div>
                );
              }
              const isSub = /^\d+\.\d+/.test(item);
              return (
                <p key={j} style={{ fontSize: isSub ? 16 : 15, fontWeight: isSub ? 700 : 400, color: isSub ? DARK : MID, lineHeight: 1.7, margin: isSub ? "24px 0 10px" : "0 0 12px" }}>
                  {item}
                </p>
              );
            })}
            {article.titre.includes("Article 10") && (
              <div style={{ background: TEAL_PALE, borderRadius: 14, padding: "20px 24px", marginTop: 16 }}>
                {[["Email", "contact@matchkid.fr"], ["Site web", "matchkid.fr"], ["Adresse", "16 rue Larrey – 75005 Paris"], ["Délai de réponse", "48 heures ouvrées"]].map(([k, v], idx) => (
                  <div key={idx} style={{ display: "flex", gap: 16, marginBottom: 8, fontSize: 14 }}>
                    <span style={{ fontWeight: 700, color: TEAL, minWidth: 140 }}>{k} :</span>
                    <span style={{ color: MID }}>{v}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        <div style={{ textAlign: "center", borderTop: `1px solid ${TEAL_PALE}`, paddingTop: 32, marginTop: 32 }}>
          <p style={{ fontSize: 13, color: "rgba(0,0,0,0.3)", fontStyle: "italic" }}>
            Matchkid — Conditions Générales de Vente — Version 1.0 — Juin 2026
          </p>
          <button onClick={onBack} style={{
            background: TEAL, color: WHITE, border: "none", borderRadius: 100,
            padding: "14px 32px", fontSize: 15, fontWeight: 700, cursor: "pointer",
            fontFamily: "system-ui", marginTop: 16
          }}>
            ← Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
}
